import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const uploadStaticAssets = async (file, customOriginalName) => {
  const errorMessages = {
    NO_FILE: 'No file was uploaded. Please select a file to upload.',
    INVALID_FILE_TYPE: 'Invalid file type. Only image files are allowed.',
    LIMIT_UNEXPECTED_FILE: 'Only one file can be uploaded at a time.',
    FILE_TOO_LARGE: 'File size exceeds the 5MB limit. Please choose a smaller file.',
    UNKNOWN_ERROR: 'An unknown error occurred during file upload. Please try again.'
  };
  try {
    const formData = new FormData();
    const fileToUpload = customOriginalName ? (() => {
      const originalExtension = file.name.split('.').pop();
      const customNameWithExtension = originalExtension ? "".concat(customOriginalName, ".").concat(originalExtension) : customOriginalName;
      return new File([file], customNameWithExtension, {
        type: file.type
      });
    })() : file;
    formData.append('file', fileToUpload);
    const response = await fetchOk("/static-assets/images/upload", {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    const {
      path
    } = data;
    return {
      imageUrl: path
    };
  } catch (error) {
    const message = errorMessages.UNKNOWN_ERROR;
    if (error && error.error) {
      var _errorData, _errorData$error;
      let errorData;
      try {
        errorData = await error.error.json();
      } catch (e) {
        /* empty */
      }
      const code = (_errorData = errorData) === null || _errorData === void 0 ? void 0 : (_errorData$error = _errorData.error) === null || _errorData$error === void 0 ? void 0 : _errorData$error.code;
      if (code && errorMessages[code]) {
        throw new Error(errorMessages[code]);
      }
    }
    throw new Error(message);
  }
};